import { ISWCValidator } from '@App/helpers/validate'
import { OptionModel } from '@Entities/lib'
import { maxByteLength } from '@Entities/schemas/common/useful-zod-functions'

// These validators check specific field of work entities and return isError: boolean

export const containsNewLine = (value: string): boolean => value.includes('\n') || value.includes('\n')
// Work detail fields //
export const workTitleInvalidCheck = (workTitle: string) =>
    !workTitle || !workTitle.length || !maxByteLength(200)(workTitle) || containsNewLine(workTitle)

export const durationInvalidCheck = (duration: string | null) => duration && !duration.match(/^[0-9]{2}[:]{1}[0-9]{2}$/)

export const copyrightOfficeNumberInvalidCheck = (copyrightOfficeNumber: string | null) =>
    copyrightOfficeNumber && copyrightOfficeNumber.length > 12

export const rightsholderProprietaryIdInvalidCheck = (rightsholderProprietaryId: string | null) =>
    rightsholderProprietaryId && rightsholderProprietaryId.length > 14

export const iswcInvalidCheck = (iswc: string | null) => iswc && !ISWCValidator(iswc)

export const languageInvalidCheck = (languageCode: number | null, langsLib: OptionModel[], required: boolean) => {
    const langIds: number[] = langsLib ? langsLib.map((lang: OptionModel) => +lang.id) : []
    if (required) {
        return !languageCode || langIds.indexOf(languageCode) === -1
    }
    return languageCode && langIds.indexOf(languageCode) === -1
}

// Recording fields //
export const recordingTitleInvalidCheck = (title: string) => !title || title.length > 100 || containsNewLine(title)

export const artistNameInvalidCheck = (artistName: string) =>
    (artistName && artistName.length > 60) || containsNewLine(artistName)

export const isrcInvalidCheck = (isrc: string | null) => {
    if (isrc) {
        if (!isrc.match(/^[0-9A-Za-z]+$/)) {
            return true
        }

        if (!isrc.substring(0, 2).match(/^[A-Za-z]+$/)) {
            return true
        }

        if (!isrc.substring(5, 12).match(/^[0-9]+$/)) {
            return true
        }

        if (isrc.length !== 12) {
            return true
        }
    }

    return false
}

export const labelInvalidCheck = (label: string | null) => label && (label.length > 60 || containsNewLine(label))
